module.exports = __webpack_public_path__ + "img/work-with-04.b0b068c.png";